(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hyphaSSEClient", [], factory);
	else if(typeof exports === 'object')
		exports["hyphaSSEClient"] = factory();
	else
		root["hyphaSSEClient"] = factory();
})(this, function() {
return 